import { Dialog, Portal, IconButton, Button } from '@welbe/design-system';
import { tokens } from '@welbe/web-design-system';
import { FiUserX, FiX } from 'react-icons/fi';
import { UploadComponent } from './UploadComponent';

type ModalResignationEmployeeProps = {
	open: boolean;
	onClose: () => void;
	onSuccess: () => void;
	onOpen: () => void;
};

const rows: string[][] = [
	[
		'Id Welbe',
		'Id Colaborador',
		'Nombre',
		'Apellido Paterno',
		'Apellido Materno',
		'Sucursal',
		'Estatus',
		'CURP',
		'NSS',
		'Nacionalidad',
		'Turno',
		'Puesto',
		'Sector',
		'Fecha de Ingresso en la Empresa',
		'Fecha de Nacimiento',
		'Genero',
		'Escolaridad',
		'Email',
		'Email Alternativo',
		'Email Corporativo',
		'Telefono',
		'Tel Alternativo',
		'Direccion',
		'Ciudad',
		'Delegacion',
		'Colonia',
		'Código Postal',
		'Estado',
		'Estado Civil',
		'Hijos',
		'Membresia',
		'Estatus Exámenes de Laboratorio',
		'Estatus Valoración Médica',
	],
];

export const ModalResignationEmployee = ({
	open,
	onClose,
	onSuccess,
	onOpen,
}: ModalResignationEmployeeProps) => {
	return (
		<Dialog.Root
			open={open}
			onOpenChange={(state: { open: boolean }) => !state.open && onClose()}
			color="#64778F"
			closeOnEscape={false}
			closeOnInteractOutside={false}
		>
			<Dialog.Trigger asChild>
				<Button
					size="sm"
					variant="outline"
					backgroundColor="white"
					_hover={{ backgroundColor: 'inherit' }}
					onClick={() => onOpen()}
				>
					Baja de colaborador <FiUserX />
				</Button>
			</Dialog.Trigger>

			<Portal>
				<Dialog.Backdrop />
				<Dialog.Positioner>
					<Dialog.Content backgroundColor="#FAFCFD" animation="slideIn">
						<Dialog.Header padding="2rem">
							<Dialog.Title
								width="100%"
								fontSize="1.125rem"
								fontWeight="600"
								color={tokens.color_primary}
								textAlign="center"
							>
								Subir Archivo
							</Dialog.Title>
						</Dialog.Header>
						<UploadComponent
							type="resignationEmployees"
							rows={rows}
							onClose={onClose}
							onSuccess={onSuccess}
						/>
						<Dialog.CloseTrigger asChild>
							<IconButton size="xs" variant="ghost">
								<FiX />
							</IconButton>
						</Dialog.CloseTrigger>
					</Dialog.Content>
				</Dialog.Positioner>
			</Portal>
		</Dialog.Root>
	);
};
